import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CajaRutaDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.Nombre }) },
    { title: "Camión asignado", cell: x => ({ data: x.UltimoStatus && x.UltimoStatus.NombreCamionAsignado }) },
    { title: "Posición", cell: x => ({ data: x.Posicion }) },
    { title: "Ruta", cell: x => ({ data: x.UltimoStatus && x.UltimoStatus.NombreRuta }) },
];

export interface BotonesDeps {
    onCargar: (x: Entity) => void;
    onDescargar: (x: Entity) => void;
    onVerCargaDescarga: (x: Entity) => void;
    onReporteManifiesto: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones<Entity>([
        {
            disabled: x => !x.PuedeCargar,
            iconClass: fa("sign-in"),
            onClick: deps.onCargar,
            tooltip: "Cargar",
            style: "success"
        }, {
            disabled: x => !x.PuedeDescargar,
            iconClass: fa("sign-out"),
            onClick: deps.onDescargar,
            tooltip: "Descargar",
            style: "danger"
        }, {
            disabled: x => x.TipoCargaDescarga == null,
            iconClass: fa("eye"),
            onClick: deps.onVerCargaDescarga,
            tooltip: "Ver carga/descarga actual",
            style: "info"
        }, {
            iconClass: fa("print"),
            onClick: deps.onReporteManifiesto,
            tooltip: "Imprimir manifiesto de caja",
            style: "info"
        }
    ]);

    return [botones, ...columnasFijas];
}




// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargacajaruta/list/cajas/columnas.tsx